module.exports = __webpack_public_path__ + "6158e765c364703980a4363531a7ebe4.png";